import { Component, Input, OnInit } from '@angular/core';
import { ModalRef } from '@freelancer/ui';
import { ModalResult } from '@freelancer/ui/modal/modal.service';

@Component({
  template: `
    <!-- TODO: Port modal to webapp stack  -->
  `,
})
export class CreateMilestoneUpgradeModalComponent implements OnInit {
  @Input() bidId: number;
  @Input() bidderId: number;
  @Input() projectId: number;

  constructor(
    private modalRef: ModalRef<CreateMilestoneUpgradeModalComponent>,
  ) {}

  ngOnInit() {
    // FIXME: port this modal to the webapp stack
    (<any>window).messagingWebappCompatModals.CreateMilestoneUpgradeModal.open({
      bidId: this.bidId,
      bidderId: this.bidderId,
      projectId: this.projectId,
    }).then((result: ModalResult) => this.close(result));
  }

  close(result: ModalResult) {
    this.modalRef.close(result);
  }
}



// WEBPACK FOOTER //
// ./src/app/projects/create-milestone-upgrade-modal/create-milestone-upgrade-modal.component.ts